export function filterForUniqueInStringArray(arr: string[]): string[] {
  const unique = [...new Set(arr)]
  return unique;
}